import React from "react";

const Terms = () => {
  return (
    <div id="account-menu-container" className="terms responsive-page">
      <p className="title">
        <strong>NYA TERMS OF USE</strong>
      </p>
      <p>
        <strong>LAST UPDATED</strong>: <strong>November 26, 2018</strong>
      </p>
      <p>
        <strong>
          Please read this Terms of Use agreement carefully. Your use of the NYA
          Service (as defined below) constitutes your agreement to this Terms of
          Use agreement.
        </strong>
      </p>
      <p>
        For the full Terms of Use, please visit{" "}
        <a href="/terms.html" target="_blank" rel="noopener noreferrer">
          this page
        </a>.
      </p>
    </div>
  );
};

export default Terms;
